import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=2d9d7d06&scoped=true"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d7d06",
  null
  
)

export default component.exports